<template>
  <v-container fluid class="dashboard-notificacoes pa-4">
    <v-container class="toolbar__container mb-2">
      <v-form ref="formNotificacoes">
        <v-row>
          <v-col cols="12" sm="6" md="2">
            <v-autocomplete
              v-model="idEmpresaSelected"
              :items="empresas"
              item-text="razao_social"
              item-value="id_empresa"
              multiple
              clearable
              :label="$tc('company.self', 1)"
              @change="empresaSelectChanged"
            />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <MultiplaEscolha
              :items="unidadesItens"
              :selected-items.sync="unidadesSelecionadas"
              text="descricao_unidade"
              value="id_unidade"
              :label="$t('nav.registration.units')"
              :max-items="2"
            />
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <MultiplaEscolha
              ref="linhasSelect"
              lazy
              get-url="getLinhaslazy"
              :request-data="linhaLazyRequestData"
              :selected-items.sync="idLinhaSelected"
              text="nome_linha"
              value="id_linha"
              :label="$tc('line.self', 1)"
              :max-items="2"
            />
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-autocomplete
              v-model="idVeiculosSelected"
              :items="veiculosSelect"
              item-text="cod_veiculo"
              item-value="id_veiculo"
              multiple
              clearable
              :label="$tc('vehicle.self', 1)"
            />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-autocomplete
              v-model="idTipoNotificacaoSelected"
              :items="tipoNotificacaoSelect"
              item-text="descricao_tipo_notificacao"
              item-value="id_tipo_notificacao"
              clearable
              multiple
              :label="$t('operation.notificationHeaders.type')"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="2">
            <v-autocomplete
              v-model="tratadaSelected"
              :items="itensSelectTratada"
              item-text="descricao"
              item-value="id"
              clearable
              :label="$t('operation.notificationHeaders.treated')"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-datetime-picker
              v-model="dti"
              :label="$t('datetime.startDate')"
              :time-picker-props="timeProps"
              :text-field-props="textFieldProps"
              :date-picker-props="dtiProps"
              time-format="HH:mm:ss"
              date-format="dd/MM/yyyy"
              :clear-text="$t('datetime.close')"
            >
              <template slot="dateIcon"><v-icon>mdi-calendar</v-icon></template>
              <template slot="timeIcon"><v-icon>mdi-clock</v-icon></template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-datetime-picker
              v-model="dtf"
              :label="$t('datetime.finalDate')"
              :time-picker-props="timeProps"
              :text-field-props="textFieldProps"
              :date-picker-props="dtfProps"
              time-format="HH:mm:ss"
              date-format="dd/MM/yyyy"
              :clear-text="$t('datetime.close')"
            >
              <template slot="dateIcon"><v-icon>mdi-calendar</v-icon></template>
              <template slot="timeIcon"><v-icon>mdi-clock</v-icon></template>
            </v-datetime-picker>
          </v-col>
          <v-col align="right" cols="12" sm="6" md="2">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  fab
                  color="primary darken-1"
                  class="white--text"
                  v-bind="attrs"
                  :loading="loading"
                  v-on="on"
                  @click="populaNotificacoes"
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('operation.search') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  fab
                  color="primary darken-1"
                  class="white--text"
                  style="margin-left: 10px"
                  v-bind="attrs"
                  v-on="on"
                  @click="limparFiltrosNotificacoes"
                >
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('operation.newConsult') }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-form>
    </v-container>

    <v-alert v-model="showAlertErro" type="error" dense dismissible class="mb-2">
      {{ mensagemAlertaErro }}
    </v-alert>

    <v-row class="dashboard-notificacoes__body">
      <v-col cols="12" md="4" class="dashboard-notificacoes__list-col">
        <v-card outlined class="fill-height">
          <v-card-title class="title-card-notificacoes py-2 flex-wrap">
            <span class="subtitle-1 font-weight-bold">{{ $t('dashboardNotifications.title') }}</span>
            <v-spacer />
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('dashboardNotifications.searchVehicle')"
              single-line
              hide-details
              dense
              clearable
              class="dashboard-notificacoes__search mr-2"
            />
            <v-chip small>{{ displayCount }}</v-chip>
          </v-card-title>
          <v-divider />
          <v-progress-linear v-if="loading" indeterminate />
          <div
            v-else
            ref="listScroll"
            class="dashboard-notificacoes__list"
            @scroll.passive="onListScroll"
          >
            <div
              class="dashboard-notificacoes__spacer"
              :style="{ height: topSpacerHeight + 'px' }"
              aria-hidden="true"
            />
            <v-list dense two-line class="dashboard-notificacoes__list-inner">
            <v-list-item
              v-for="item in visibleNotificacoes"
              :key="item.id_notificacao"
              class="dashboard-notificacoes__list-item"
              :class="{ 'dashboard-notificacoes__list-item--active': item.id_notificacao === selectedId }"
              @click="selectNotificacao(item)"
            >
              <v-list-item-avatar>
                <v-icon :color="item.cor || 'grey'">mdi-bell-alert</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-truncate">
                  {{ item.cod_veiculo }} — {{ item.descricao_tipo_notificacao }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ item.dt_notificacao_extenso }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-chip v-if="item.reset == 0" x-small color="error" outlined>
                  {{ $t('dashboardNotifications.pending') }}
                </v-chip>
              </v-list-item-action>
            </v-list-item>
            <v-list-item v-if="displayCount === 0" class="dashboard-notificacoes__list-item">
              <v-list-item-content>
                <v-list-item-title class="grey--text text-center">
                  {{ $t('system.messages.noData') }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
            <div
              class="dashboard-notificacoes__spacer"
              :style="{ height: bottomSpacerHeight + 'px' }"
              aria-hidden="true"
            />
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" md="8" class="dashboard-notificacoes__detail-col" style="padding-left: 10px;">
        <v-card v-if="selected" outlined class="fill-height">
          <v-card-title class="title-card-notificacoes py-2 flex-wrap">
            <span class="subtitle-1 font-weight-bold">{{ selected.descricao_tipo_notificacao }}</span>
            <v-spacer />
            <v-btn
              color="primary"
              class="mr-2"
              small
              :disabled="selected.reset != 0"
              @click="showResetDialog"
            >
              <v-icon left small>mdi-check-circle</v-icon>
              {{ $t('dashboardNotifications.treat') }}
            </v-btn>
            <v-btn color="green darken-1" class="white--text" small @click="showDialogMapaNotificacoes(selected)">
              <v-icon left small>mdi-map-marker</v-icon>
              {{ $t('dashboardNotifications.openMap') }}
            </v-btn>
          </v-card-title>
          <v-divider />

          <v-card-text>
            <v-alert v-if="gpsStale" type="error" dense prominent class="mb-3">
              {{ $t('dashboardNotifications.gpsStale') }}
            </v-alert>
            <div class="mb-3">
              <v-chip v-if="highPriority" color="orange darken-2" class="white--text mr-2" small>
                {{ $t('dashboardNotifications.highPriority') }}
              </v-chip>
              <v-chip v-if="selected.gps_offline == 1" color="amber darken-3" class="mr-2" small>
                GPS offline
              </v-chip>
            </div>

            <v-card flat outlined class="mb-3 pa-3">
              <div class="subtitle-2 mb-2">{{ $t('dashboardNotifications.sections.vehicleEvent') }}</div>
              <v-row dense>
                <v-col cols="6" sm="4"><strong>{{ $t('notificationMap.fields.vehicleCode') }}:</strong> {{ selected.cod_veiculo }}</v-col>
                <v-col cols="6" sm="4"><strong>{{ $t('notificationMap.fields.orderNumber') }}:</strong> {{ selected.numero_ordem || '—' }}</v-col>
                <v-col cols="6" sm="4"><strong>{{ $t('notificationMap.fields.vehicleType') }}:</strong> {{ selected.descricao_tipo_veiculo || '—' }}</v-col>
                <v-col cols="12" sm="6"><strong>{{ $t('notificationMap.fields.date') }}:</strong> {{ selected.dt_notificacao_extenso }}</v-col>
                <v-col cols="12" sm="6"><strong>{{ $t('relNotification.header.geofence') }}:</strong> {{ selected.nome_cerca || '—' }}</v-col>
                <v-col cols="12" sm="6"><strong>{{ $t('relNotification.header.line') }}:</strong> {{ selected.nome_linha || '—' }}</v-col>
                <v-col cols="12" sm="6"><strong>{{ $t('relNotification.header.treated') }}:</strong> {{ selected.reset_extenso }}</v-col>
              </v-row>
            </v-card>

            <v-card flat outlined class="mb-3 pa-3">
              <div class="subtitle-2 mb-2">{{ $t('dashboardNotifications.sections.telemetry') }}</div>
              <v-row dense>
                <v-col cols="12" sm="6"><strong>{{ $t('notificationMap.fields.lastPosition') }}:</strong> {{ selected.dt_ultima_posicao || '—' }}</v-col>
                <v-col cols="12" sm="6"><strong>{{ $t('relNotification.header.billOutArea') }}:</strong> {{ selected.bil_fora_area_extenso }}</v-col>
                <v-col cols="12" sm="6"><strong>{{ $t('notificationMap.fields.driver') }} (guia):</strong> {{ selected.nome_motorista_guia || '—' }}</v-col>
                <v-col cols="12" sm="6"><strong>{{ $t('notificationMap.fields.collector') }} (guia):</strong> {{ selected.nome_cobrador_guia || '—' }}</v-col>
                <v-col cols="12" sm="6"><strong>{{ $t('notificationMap.fields.driver') }} (validador):</strong> {{ validadorMotorista }}</v-col>
                <v-col cols="12" sm="6"><strong>{{ $t('notificationMap.fields.collector') }} (validador):</strong> {{ validadorCobrador }}</v-col>
              </v-row>
            </v-card>

            <v-card flat outlined class="pa-3">
              <div class="subtitle-2 mb-2 d-flex align-center flex-wrap">
                <span>{{ $t('notificationMap.address') }}</span>
                <v-spacer />
                <v-btn
                  v-if="canFetchAddress"
                  small
                  outlined
                  color="primary"
                  :loading="geocoding"
                  :disabled="geocoding"
                  @click="fetchAddress(selected)"
                >
                  <v-icon left small>mdi-map-marker</v-icon>
                  {{ $t('notificationMap.getAddress') }}
                </v-btn>
              </div>
              <v-progress-linear v-if="geocoding" indeterminate class="mb-2" />
              <template v-else-if="hasAddress">
                <div>{{ enderecoFormatado }}</div>
              </template>
              <div v-else class="grey--text">{{ $t('dashboardNotifications.noAddress') }}</div>
            </v-card>
          </v-card-text>
        </v-card>

        <v-card v-else outlined class="fill-height d-flex align-center justify-center pa-8">
          <span class="grey--text">{{ $t('dashboardNotifications.selectAlert') }}</span>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="confirmResetDialog" persistent max-width="480">
      <v-card>
        <v-card-title>{{ $t('system.alert') }}</v-card-title>
        <v-card-text>{{ $t('relNotification.confirmReset') }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="confirmResetDialog = false">{{ $t('button.cancel') }}</v-btn>
          <v-btn color="primary" @click="resetNotificacao">{{ $t('button.confirmOk') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="progressoDialog" persistent max-width="400">
      <v-card>
        <v-card-text class="pt-4 text-center">
          <v-progress-circular indeterminate color="primary" />
          <p class="mt-3 mb-0">{{ mensagemProgressoDialog }}</p>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogMapa" fullscreen style="z-index: 80000">
      <MapaNotificacao
        v-if="dialogMapa && itemMapaNotificacao[0]"
        :item-mapa-notificacao="itemMapaNotificacao[0]"
        :lat-notificacao="latNotificacao"
        :lng-notificacao="lngNotificacao"
        :dt-posicao-notificacao="dtPosicaoNotificacao"
        :item-endereco-import="itemEndereco[0]"
        :user="user"
        :token="token"
        :bilhetagens="bilhetagens"
        :key="mapKey"
        :has_validador="showInfoValidador"
        @close="closeDialogMapaNotificacoes"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import apiController from "@/utils/apiController";
import DateUtils from "../utils/dateutils";
import translateDbField from "@/utils/translateDbField";
import MultiplaEscolha from "./Selects/MultiplaEscolha.vue";

const HERE_API_KEY = "FOvzDukk0SIaGv8RRFW50DQypjKr9HgD7hsV-S3NXFg";
const LIST_PAGE_SIZE = 50;
const LIST_ITEM_HEIGHT = 68;
const LIST_BUFFER_PAGES = 1;
const HAS_ADDRESS = "Sim";

function parseBrDateTime(str) {
  if (!str || typeof str !== "string") return null;
  const m = str.match(/^(\d{2})\/(\d{2})\/(\d{4})\s+(\d{2}):(\d{2}):(\d{2})/);
  if (!m) return null;
  return new Date(
    Number(m[3]),
    Number(m[2]) - 1,
    Number(m[1]),
    Number(m[4]),
    Number(m[5]),
    Number(m[6])
  );
}

function buildSearchText(n) {
  return `${n.cod_veiculo || ""} ${n.descricao_tipo_notificacao || ""}`.toLowerCase();
}

function ingestNotificacoes(rawList) {
  const byId = new Map();
  const orderIds = [];
  const searchTextById = new Map();
  for (const raw of rawList) {
    const n = {
      ...raw,
      descricao_tipo_notificacao: translateDbField(
        raw.translation_key,
        raw.descricao_tipo_notificacao
      ),
    };
    const id = n.id_notificacao;
    byId.set(id, n);
    orderIds.push(id);
    searchTextById.set(id, buildSearchText(n));
  }
  return { byId, orderIds, searchTextById };
}

export default {
  name: "DashboardNotificacoes",
  components: {
    MapaNotificacao: () => import("./MapaNotificacao.vue"),
    MultiplaEscolha,
  },
  data() {
    return {
      user: null,
      token: null,
      config: null,
      platform: null,
      loading: false,
      geocoding: false,
      search: "",
      searchDebounced: "",
      searchTimer: null,
      notificacoesById: new Map(),
      allOrderIds: [],
      displayOrderIds: [],
      searchTextById: new Map(),
      selected: null,
      selectedId: null,
      scrollWindowStart: 0,
      scrollWindowEnd: LIST_PAGE_SIZE * 2,
      scrollRafId: null,
      dti: null,
      dtf: null,
      tratadaSelected: null,
      recursos: [],
      empresas: [],
      veiculos: [],
      veiculosSelect: [],
      unidades: [],
      unidadesSelecionadas: [],
      idEmpresaSelected: [],
      idLinhaSelected: [],
      idVeiculosSelected: [],
      idTipoNotificacaoSelected: [],
      tipoNotificacaoSelect: [],
      bilhetagemForaAreaSelected: null,
      empresasReady: false,
      pendingInitialLoad: true,
      showAlertErro: false,
      mensagemAlertaErro: "",
      confirmResetDialog: false,
      progressoDialog: false,
      mensagemProgressoDialog: "",
      dialogMapa: false,
      mapKey: 0,
      setup: { has_validador: 0 },
      timeProps: { useSeconds: true },
      itemMapaNotificacao: [{}],
      itemEndereco: [{ street: "", houseNumber: "", district: "", city: "", stateCode: "", postalCode: "" }],
      latNotificacao: null,
      lngNotificacao: null,
      dtPosicaoNotificacao: null,
      idVeiculoNotificacao: null,
      bilhetagens: [],
      polygonNotificacoes: { latlngs: [], color: "blue" },
      polylineNotificacoes: { latlngs: [], color: "red" },
      showPolygonNotificacao: false,
      showPolylineNotificacao: false,
      enderecoLocal: null,
    };
  },
  computed: {
    unidadesItens() {
      return this.unidades;
    },
    /**
     * Filtros de empresa e unidade repassados ao getlinhaslazy. O endpoint aceita
     * varias unidades (inclusive -1 = sem unidade) e varias empresas, entao o
     * cruzamento que era feito em memoria acontece no servidor.
     */
    linhaLazyRequestData() {
      const dados = {};
      const unidades = (this.unidadesSelecionadas || [])
        .map((id) => Number(id))
        .filter((id) => Number.isFinite(id));
      if (unidades.length > 0) {
        dados.id_unidades = unidades;
      }
      const empresas = (this.idEmpresaSelected || [])
        .map((id) => Number(id))
        .filter((id) => Number.isFinite(id) && id > 0);
      if (empresas.length > 0) {
        dados.id_empresas = empresas;
      }
      return dados;
    },
    itensSelectTratada() {
      return [
        { id: "0", descricao: this.$t("button.dismiss") },
        { id: "1", descricao: this.$t("button.confirm") }];
    },
    textFieldProps() {
      return {
        prependInnerIcon: "mdi-calendar",
        rules: [(v) => !!v || this.$t("contract.messages.selectDate")],
      };
    },
    today() {
      return new Date().toISOString().substring(0, 10);
    },
    dtiProps() {
      return { max: this.today };
    },
    dtfProps() {
      let min = null;
      if (this.dti) {
        if (typeof this.dti === "string") {
          min = `${this.dti.substring(6, 10)}-${this.dti.substring(3, 5)}-${this.dti.substring(0, 2)}`;
        } else {
          min = this.dti.toISOString().substring(0, 10);
        }
      }
      return { min };
    },
    displayCount() {
      return this.displayOrderIds.length;
    },
    topSpacerHeight() {
      return this.scrollWindowStart * LIST_ITEM_HEIGHT;
    },
    bottomSpacerHeight() {
      const remaining = this.displayCount - this.scrollWindowEnd;
      return Math.max(0, remaining) * LIST_ITEM_HEIGHT;
    },
    visibleNotificacoes() {
      const { notificacoesById, displayOrderIds, scrollWindowStart, scrollWindowEnd } = this;
      const items = [];
      for (let i = scrollWindowStart; i < scrollWindowEnd && i < displayOrderIds.length; i++) {
        const item = notificacoesById.get(displayOrderIds[i]);
        if (item) items.push(item);
      }
      return items;
    },
    gpsStale() {
      if (!this.selected) return false;
      const alertDt = parseBrDateTime(this.selected.dt_notificacao_extenso);
      const gpsDt = parseBrDateTime(this.selected.dt_ultima_posicao);
      if (!alertDt || !gpsDt) return false;
      const diffMs = alertDt.getTime() - gpsDt.getTime();
      return diffMs > 60 * 60 * 1000;
    },
    highPriority() {
      return this.selected && Number(this.selected.bilhetagem_fora_area) === 1;
    },
    showInfoValidador() {
      return this.setup.has_validador === 1;
    },
    validadorMotorista() {
      if (!this.selected) return "—";
      const m = this.selected.matr_motorista_validador;
      const n = this.selected.nome_motorista_validador;
      return m ? `(${m}) — ${n}` : "—";
    },
    validadorCobrador() {
      if (!this.selected) return "—";
      const m = this.selected.matr_cobrador_validador;
      const n = this.selected.nome_cobrador_validador;
      return m ? `(${m}) — ${n}` : "—";
    },
    hasAddress() {
      if (this.enderecoLocal) return true;
      if (!this.selected) return false;
      return this.selected.tem_endereco === HAS_ADDRESS;
    },
    canFetchAddress() {
      return this.selected && this.selected.lat && this.selected.lng && !this.hasAddress;
    },
    enderecoFormatado() {
      if (this.enderecoLocal) {
        const e = this.enderecoLocal;
        return [e.street, e.houseNumber, e.district, e.city, e.stateCode].filter(Boolean).join(", ");
      }
      if (!this.selected) return "";
      return [this.selected.rua, this.selected.numero, this.selected.bairro, this.selected.cidade, this.selected.uf]
        .filter(Boolean)
        .join(", ");
    },
  },
  watch: {
    "$i18n.locale"() {
      this.populaTipoNotificacaoSelect();
      this.pendingInitialLoad = true;
      this.getConfig();
    },
    search(val) {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.searchDebounced = val;
        this.buildDisplayList();
      }, 300);
    },
    unidadesSelecionadas() {
      this.populaVeiculosSelect();
      this.empresaSelectChanged();
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.populaTipoNotificacaoSelect();
    this.populaRecursos();
    this.populaUnidades();
    this.getConfig();
    this.populaSetup();
  },
  beforeDestroy() {
    clearTimeout(this.searchTimer);
    if (this.scrollRafId) cancelAnimationFrame(this.scrollRafId);
  },
  methods: {
    ensurePlatform() {
      if (!this.platform && window.H && window.H.service) {
        this.platform = new window.H.service.Platform({ apikey: HERE_API_KEY });
      }
      return this.platform;
    },
    ingestNotificacoesFromApi(rawList) {
      const { byId, orderIds, searchTextById } = ingestNotificacoes(rawList);
      this.notificacoesById = byId;
      this.allOrderIds = orderIds;
      this.searchTextById = searchTextById;
      this.buildDisplayList();
    },
    buildDisplayList() {
      const q = (this.searchDebounced || "").trim().toLowerCase();
      if (!q) {
        this.displayOrderIds = this.allOrderIds;
      } else {
        const ids = [];
        const { allOrderIds, searchTextById } = this;
        for (let i = 0; i < allOrderIds.length; i++) {
          const id = allOrderIds[i];
          const text = searchTextById.get(id);
          if (text && text.includes(q)) ids.push(id);
        }
        this.displayOrderIds = ids;
      }
      this.resetScrollWindow();
      this.$nextTick(() => {
        const el = this.$refs.listScroll;
        if (el) {
          el.scrollTop = 0;
          this.updateScrollWindow(el);
        }
        if (this.selectedId) this.ensureSelectedVisible();
      });
    },
    resetScrollWindow() {
      const total = this.displayOrderIds.length;
      if (total === 0) {
        this.scrollWindowStart = 0;
        this.scrollWindowEnd = 0;
        return;
      }
      this.scrollWindowStart = 0;
      this.scrollWindowEnd = Math.min(total, LIST_PAGE_SIZE * (1 + LIST_BUFFER_PAGES));
    },
    onListScroll(event) {
      if (this.scrollRafId) return;
      const el = event.target;
      this.scrollRafId = requestAnimationFrame(() => {
        this.scrollRafId = null;
        this.updateScrollWindow(el);
      });
    },
    updateScrollWindow(el) {
      if (!el || this.displayCount === 0) return;

      const total = this.displayCount;
      const pageSize = LIST_PAGE_SIZE;
      const bufferItems = pageSize * LIST_BUFFER_PAGES;
      const viewportItems = Math.ceil(el.clientHeight / LIST_ITEM_HEIGHT) + 2;

      let startIndex = Math.floor(el.scrollTop / LIST_ITEM_HEIGHT) - bufferItems;
      startIndex = Math.max(0, startIndex);
      startIndex = Math.floor(startIndex / pageSize) * pageSize;

      let endIndex = startIndex + viewportItems + bufferItems * 2;
      const pageEnd = Math.ceil(endIndex / pageSize) * pageSize;
      endIndex = Math.min(total, Math.max(pageEnd, startIndex + pageSize));

      if (startIndex === this.scrollWindowStart && endIndex === this.scrollWindowEnd) return;

      this.scrollWindowStart = startIndex;
      this.scrollWindowEnd = endIndex;
    },
    ensureSelectedVisible() {
      if (!this.selectedId) return;
      const idx = this.displayOrderIds.indexOf(this.selectedId);
      if (idx < 0) return;

      const pageSize = LIST_PAGE_SIZE;
      const page = Math.floor(idx / pageSize);
      const pageStart = page * pageSize;
      const pageEnd = Math.min(this.displayCount, (page + 1 + LIST_BUFFER_PAGES) * pageSize);

      if (idx < this.scrollWindowStart || idx >= this.scrollWindowEnd) {
        this.scrollWindowStart = pageStart;
        this.scrollWindowEnd = pageEnd;
      }

      this.$nextTick(() => {
        const el = this.$refs.listScroll;
        if (!el) return;
        el.scrollTop = idx * LIST_ITEM_HEIGHT;
        this.updateScrollWindow(el);
        const active = el.querySelector(".dashboard-notificacoes__list-item--active");
        if (active && active.scrollIntoView) {
          active.scrollIntoView({ block: "nearest" });
        }
      });
    },
    selectNotificacao(itemOrId) {
      const id =
        typeof itemOrId === "object" && itemOrId != null
          ? itemOrId.id_notificacao
          : itemOrId;
      const item = this.notificacoesById.get(id);
      if (!item) return;
      this.selected = item;
      this.selectedId = id;
      this.enderecoLocal = null;
      if (item.tem_endereco === HAS_ADDRESS) {
        this.enderecoLocal = {
          street: item.rua,
          houseNumber: item.numero,
          district: item.bairro,
          city: item.cidade,
          stateCode: item.uf,
        };
      }
    },
    idsUnidadesNoObjeto(o) {
      if (Array.isArray(o.unidades) && o.unidades.length) {
        return o.unidades.map((id) => Number(id));
      }
      if (o.id_unidade != null && o.id_unidade !== "") {
        return [Number(o.id_unidade)];
      }
      return [];
    },
    passaFiltroUnidades(o) {
      if (this.unidadesSelecionadas.length === 0) {
        return true;
      }
      const selecionadas = this.unidadesSelecionadas.map((id) => Number(id));
      return this.idsUnidadesNoObjeto(o).some((id) => selecionadas.includes(id));
    },
    populaRecursos() {
      const onSuccess = (response) => {
        this.recursos = response.data || [];
        this.populaEmpresas();
        this.populaVeiculos();
      };
      if (this.user.is_superadmin === 1) {
        apiController.request(apiController.endpoints.getallRecursos, { onSuccess });
      } else {
        apiController.request(apiController.endpoints.getRecursosusuario, {
          params: { id: this.user.id_usuario },
          onSuccess,
        });
      }
    },
    populaVeiculos() {
      apiController.request(apiController.endpoints.getallVeiculosativos, {
        onSuccess: (response) => {
          this.veiculos = response.data || [];
          this.populaVeiculosSelect();
        },
      });
    },
    passaFiltroEmpresa(obj) {
      if (!this.idEmpresaSelected || this.idEmpresaSelected.length === 0) {
        return true;
      }
      return this.idEmpresaSelected.includes(obj.id_empresa);
    },
    populaVeiculosSelect() {
      let veiculosFiltrados = this.veiculos.filter((v) => this.passaFiltroEmpresa(v));
      veiculosFiltrados = veiculosFiltrados.filter((v) => this.passaFiltroUnidades(v));
      this.veiculosSelect = veiculosFiltrados;
    },
    empresaSelectChanged() {
      // As linhas sao filtradas pelo servidor (linhaLazyRequestData); aqui sobram os veiculos.
      this.populaVeiculosSelect();
    },
    populaTipoNotificacaoSelect() {
      apiController.request(apiController.endpoints.getallTiposnotificacoes, {
        onSuccess: (response) => {
          this.tipoNotificacaoSelect = response.data
            .filter((t) => t.show_relatorio === 1)
            .map((t) => ({
              ...t,
              descricao_tipo_notificacao: translateDbField(
                t.translation_key,
                t.descricao_tipo_notificacao
              ),
            }));
        },
      });
    },
    populaUnidades() {
      apiController.request(apiController.endpoints.getallUnidadesativas, {
        onSuccess: (response) => {
          this.unidades = [
            { id_unidade: -1, descricao_unidade: "Sem Unidade", cod_unidade: "SU" },
            ...(response.data || [])];
        },
      });
    },
    limparFiltrosNotificacoes() {
      if (this.config) {
        [this.dti, this.dtf] = DateUtils.setDefaultDateFilters(this.config.hora_inicial_dia_operacao);
      }
      this.idEmpresaSelected = [];
      this.idLinhaSelected = [];
      this.idVeiculosSelected = [];
      this.idTipoNotificacaoSelected = [];
      this.tratadaSelected = null;
      this.bilhetagemForaAreaSelected = null;
      this.unidadesSelecionadas = [];
      this.search = "";
      this.searchDebounced = "";
      this.showAlertErro = false;
      this.notificacoesById = new Map();
      this.allOrderIds = [];
      this.displayOrderIds = [];
      this.searchTextById = new Map();
      this.selected = null;
      this.selectedId = null;
      this.resetScrollWindow();
      this.populaEmpresas();
      this.populaTipoNotificacaoSelect();
    },
    populaEmpresas() {
      const seen = new Map();
      (this.recursos || []).forEach((r) => {
        if (r.id_empresa && !seen.has(r.id_empresa)) {
          seen.set(r.id_empresa, {
            id_empresa: r.id_empresa,
            razao_social: r.razao_social,
          });
        }
      });
      this.empresas = Array.from(seen.values());
      this.empresasReady = true;
      if (this.empresas.length === 1) {
        this.idEmpresaSelected = [this.empresas[0].id_empresa];
        this.empresaSelectChanged();
      }
      this.tryInitialLoad();
    },
    tryInitialLoad() {
      if (!this.config || !this.empresasReady || !this.pendingInitialLoad) return;
      this.pendingInitialLoad = false;
      this.populaNotificacoes();
    },
    getConfig() {
      apiController.request(apiController.endpoints.getallConfig, {
        onSuccess: (response) => {
          this.config = response.data[0];
          [this.dti, this.dtf] = DateUtils.setDefaultDateFilters(this.config.hora_inicial_dia_operacao);
          this.tryInitialLoad();
        },
      });
    },
    populaSetup() {
      apiController.request(apiController.endpoints.getallParametrossetup, {
        onSuccess: (response) => {
          this.setup = Object.assign({}, response.data[0]);
        },
      });
    },
    populaNotificacoes() {
      const dti = DateUtils.getDateSQLFormatted(this.dti);
      const dtf = DateUtils.getDateSQLFormatted(this.dtf);
      if (dti > dtf) {
        this.mensagemAlertaErro = this.$t("datetime.startDateAfterEndDate");
        this.showAlertErro = true;
        return;
      }
      this.loading = true;
      const params = {
        dtinicio: dti,
        dtfim: dtf,
        idempresa: this.idEmpresaSelected.length > 0 ? this.idEmpresaSelected : null,
        idlinha: this.idLinhaSelected.length > 0 ? this.idLinhaSelected : null,
        idveiculo: this.idVeiculosSelected,
        tiponotificacao: this.idTipoNotificacaoSelected,
        tratada: this.tratadaSelected,
        bilhetagemfora: this.bilhetagemForaAreaSelected,
      };
      apiController.request(apiController.endpoints.getNotificacoespordata, {
        data: params,
        onSuccess: (response) => {
          const filtered = (response.data || []).filter((n) => this.passaFiltroUnidades(n));
          this.ingestNotificacoesFromApi(filtered);
          const prevId = this.selectedId;
          if (prevId && this.notificacoesById.has(prevId)) {
            this.selectNotificacao(prevId);
          } else if (this.displayOrderIds.length > 0) {
            this.selectNotificacao(this.displayOrderIds[0]);
          } else {
            this.selected = null;
            this.selectedId = null;
          }
          this.loading = false;
        },
        onError: () => {
          this.loading = false;
        },
      });
    },
    fetchAddress(item) {
      const platform = this.ensurePlatform();
      if (!platform || !item.lat || !item.lng) return;
      this.geocoding = true;
      const service = platform.getSearchService();
      service.reverseGeocode(
        { at: `${item.lat},${item.lng}` },
        (result) => {
          const addr = result.items[0].address;
          this.enderecoLocal = {
            street: addr.street,
            houseNumber: addr.houseNumber,
            district: addr.district,
            city: addr.city,
            stateCode: addr.stateCode,
            postalCode: addr.postalCode,
          };
          apiController.request(apiController.endpoints.updateEndereconotificacao, {
            data: {
              id_notificacao: item.id_notificacao,
              endereco: [this.enderecoLocal],
            },
            silent: true,
          });
          this.geocoding = false;
        },
        () => {
          this.geocoding = false;
        }
      );
    },
    showResetDialog() {
      if (!this.selected || this.selected.reset != 0) return;
      this.confirmResetDialog = true;
    },
    resetNotificacao() {
      this.confirmResetDialog = false;
      this.mensagemProgressoDialog = this.$t("relNotification.resettingNotificationWait");
      this.progressoDialog = true;
      apiController.request(apiController.endpoints.updateNotificacao, {
        data: { id_notificacao: this.selected.id_notificacao },
        onSuccess: () => {
          this.progressoDialog = false;
          this.populaNotificacoes();
        },
        onError: () => {
          this.progressoDialog = false;
        },
      });
    },
    showDialogMapaNotificacoes(item) {
      if (item.tem_endereco === HAS_ADDRESS) {
        this.itemEndereco = [
          {
            street: item.rua,
            houseNumber: item.numero,
            district: item.bairro,
            city: item.cidade,
            stateCode: item.uf,
            postalCode: item.cep,
          }];
      } else if (this.enderecoLocal) {
        this.itemEndereco = [{ ...this.enderecoLocal, postalCode: this.enderecoLocal.postalCode || "" }];
      } else {
        this.itemEndereco = [{ street: "", houseNumber: "", district: "", city: "", stateCode: "", postalCode: "" }];
      }

      this.itemMapaNotificacao = [item];
      this.dtPosicaoNotificacao = item.dt_ultima_posicao;
      this.latNotificacao = item.lat;
      this.lngNotificacao = item.lng;

      const dti =
        item.dt_notificacao_extenso.substr(6, 4) +
        item.dt_notificacao_extenso.substr(3, 2) +
        item.dt_notificacao_extenso.substr(0, 2);

      this.polygonNotificacoes.latlngs = [];
      this.polylineNotificacoes.latlngs = [];
      this.showPolygonNotificacao = false;
      this.showPolylineNotificacao = false;

      if (item.tem_area == 1) {
        apiController.request(apiController.endpoints.getAreaporid, {
          params: { id: item.id_area },
          onSuccess: (response) => {
            if (response.data.length > 0) {
              this.polygonNotificacoes.latlngs = this.parseShape(response.data[0].shape);
              this.showPolygonNotificacao = true;
            }
          },
        });
        this.idVeiculoNotificacao = item.id_veiculo;
        this.populaBilhetagens(dti + "000000", dti + "235959");
      }

      if (item.tem_cerca == 1) {
        apiController.request(apiController.endpoints.getCercaporid, {
          params: { id: item.id_cerca },
          onSuccess: (response) => {
            if (response.data.length > 0) {
              this.polygonNotificacoes.latlngs = this.parseShape(response.data[0].shape);
              this.showPolygonNotificacao = true;
            }
          },
        });
      }

      if (item.tem_linha == 1) {
        apiController.request(apiController.endpoints.getRotaporid, {
          params: { id: item.id_rota },
          onSuccess: (response) => {
            if (response.data.length > 0) {
              this.polylineNotificacoes.latlngs = this.parseShape(response.data[0].shape);
              this.showPolylineNotificacao = true;
            }
          },
        });
      }

      if (item.id_tipo_notificacao == 13 || item.id_tipo_notificacao == 9) {
        this.dtPosicaoNotificacao = item.dt_ult_posicao_bilhetagem;
        this.latNotificacao = item.lat_bilhetagem;
        this.lngNotificacao = item.lng_bilhetagem;
      }
      if (item.gps_offline == 1) {
        this.dtPosicaoNotificacao = item.dt_ultima_posicao;
        this.latNotificacao = item.lat;
        this.lngNotificacao = item.lng;
      }

      this.mapKey += 1;
      this.dialogMapa = true;
    },
    parseShape(shape) {
      const coords = [];
      if (!shape) return coords;
      const array = JSON.parse(shape);
      for (let i = 0; i < array.length; i++) {
        coords.push({ lng: array[i].lg, lat: array[i].lt });
      }
      return coords;
    },
    populaBilhetagens(dti, dtf) {
      apiController.request(apiController.endpoints.getBilhetagensporcarrodata, {
        data: { id: this.idVeiculoNotificacao, dti, dtf },
        onSuccess: (response) => {
          this.bilhetagens = response.data && response.data.length > 0 ? response.data : [];
        },
      });
    },
    closeDialogMapaNotificacoes() {
      this.dialogMapa = false;
      this.bilhetagens = [];
    },
  },
};
</script>

<style scoped>
.title-card-notificacoes {
  height: 3em;
}
.toolbar__container {
  height: fit-content;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0px 5px 5px grey;
  padding: 20px 15px;
  max-width: 90%;
  margin: 0 auto;
}
.dashboard-notificacoes__search {
  max-width: 220px;
}
.dashboard-notificacoes__body {
  min-height: calc(100vh - 300px);
  max-width: 90%;
  margin: 0 auto;
}
.dashboard-notificacoes__list-col,
.dashboard-notificacoes__detail-col {
  max-height: calc(100vh - 300px);
  padding: 10px 0;
}
.dashboard-notificacoes__list {
  max-height: calc(100vh - 360px);
  overflow-y: auto;
  overflow-x: hidden;
}
.dashboard-notificacoes__list-inner {
  padding: 0;
}
.dashboard-notificacoes__spacer {
  flex-shrink: 0;
  width: 100%;
}
.dashboard-notificacoes__list-item {
  min-height: 68px;
  height: 68px;
  box-sizing: border-box;
}
.dashboard-notificacoes__list-item--active {
  background: rgba(25, 118, 210, 0.12);
}
</style>
